export var ItemisedBilling;
(function (ItemisedBilling) {
    ItemisedBilling["None"] = "no";
    ItemisedBilling["Partial"] = "partial";
    ItemisedBilling["Full"] = "full";
})(ItemisedBilling || (ItemisedBilling = {}));
